/* eslint-disable import/order, no-console, eol-last */
import interact from "../../interact/index.js";
import plugin from "./plugin.js";
interact.use(plugin);
//# sourceMappingURL=index.js.map